<div class="grid grid-cols-12">
    @if (isBrowser) {
        <div (window:resize)="windowResize()"></div>
    }
    @if (this.displayHeader) {
        <header #pageHeader class="sticky-top col-span-12">
            <div class="header-container flex px-2 header items-center">
                @if (!quoteController.hideBackButton()) {
                    <div class="absolute">
                        <a
                            (click)="onBackClick()"
                            class="back-container no-underline">
                            <i class="text-base icon-arrow-back"></i>
                            <strong class="text-xs sm:text-sm font-bold">
                                Terug
                            </strong>
                        </a>
                    </div>
                }
                <div class="flex px-2 justify-center flex-1 items-center">
                    <img
                        (click)="onLogoClick()"
                        alt="virseker logo"
                        class="logo"
                        width="156"
                        height="49"
                        [ngSrc]="
                            assetsUrl() +
                            '/14b6f458-18ec-421f-a34e-f414932e6df3/virseker-logo.svg'
                        " />
                </div>
                @if (envDebugDrawer()) {
                    <div class="debug-icon" (click)="onDebugClick()">
                        <i class="icon text-base icon-bug"></i>
                    </div>
                }
            </div>
        </header>
    }
    <section>
        <debug-display-widget
            [visible]="showDebug"
            (closed)="showDebug = false"
            ngSkipHydration
            [sections]="debugSections"
            [leadNumber]="leadNumber()"></debug-display-widget>
    </section>
    @if (!quoteController.hideTrackbar()) {
        <section class="col-span-12">
            <div class="header-widget-container pt-5 px-1 pb-6">
                <track-bar-widget
                    ngSkipHydration
                    class="flex flex-auto mb-7 mt-3 px-3 xs:px-8"
                    completedIcon="icon-circle-check-filled"
                    primaryColour="var(--virseker-blue)"
                    secondaryColour="var(--virseker-grey-3)"
                    textColour="var(--dark-grey)"
                    completeSectionTextColour="var(--dark-grey)"></track-bar-widget>
            </div>
        </section>
    }
    @if (
        isFocused &&
        isMobile &&
        quoteController.minifyTrackbar &&
        isPageScrolled
    ) {
        <section class="col-span-12">
            <div class="header-widget-container">
                <mini-track-bar
                    class="flex mb-3"
                    completedIcon="icon-circle-check-filled"
                    primaryColour="var(--main-1)"
                    secondaryColour="var(--sub-4)"
                    textColour="var(--sub-5)"
                    completeSectionTextColour="var(--sub-5)"></mini-track-bar>
            </div>
        </section>
    }
    @if (quoteController.showPremiumBanner()) {
        <section
            slideElementInOut
            [slideEnabled]="quoteController.slidePremiumBanner()"
            [slideTriggerPoint]="295"
            class="col-span-12 sticky bg-virseker-dark-blue z-20 mb-6"
            [ngClass]="
                quoteController.slidePremiumBanner()
                    ? this.displayHeader
                        ? 'premium-banner-animate slide-out'
                        : 'premium-banner-animate-no-header slide-out'
                    : 'sticky'
            "
            [style.top]="
                quoteController.slidePremiumBanner() ? null : premiumTop
            ">
            <base-container [hasBottomPadding]="false" [showLoader]="false">
                <premium-banner-simple-widget
                    [styles]="{
                        loaderHeight: '32px',
                        premiumTextClass:
                            'text-xl font-black relative flex justify-center',
                    }"
                    primaryColour="var(--virseker-dark-blue)"
                    discountColour="var(--virseker-dark-blue)"
                    [showDiscount]="true"></premium-banner-simple-widget>
            </base-container>
        </section>
    }

    <main class="content col-span-12">
        <router-outlet></router-outlet>
    </main>
</div>
